<template>
  <div class="grid col-12">
    <div class="card">
      <form class="card" @submit.prevent="onSubmit">
        <Errors v-show="this.errors.length > 0" :errors="this.errors" />
        <div class="grid">
          <!-- NIF/NIE/CIF -->
          <div class="col-12 md:col-6 p-p-field">
            <label for="nifNieCif"
              ><b
                >{{ $t("cuentaYFacturacion.datosFacturacion.nifNieCif") }}*</b
              ></label
            >
            <div class="p-inputgroup">
              <InputText
                class="input"
                :class="!validations.nifNieCif ? 'p-invalid' : ''"
                id="nifCifNie"
                type="text"
                v-model="datosFacturacion.nifNieCif"
                @change="onNifNieCifChange"
              />
            </div>
            <small v-if="!validations.nifNieCif" class="p-invalid">{{
              this.$t("common.formularios.mandatoryp-field")
            }}</small>
          </div>
          <!-- Teléfono -->
          <div class="col-12 md:col-6 p-field">
            <label for="telefono"
              ><b
                >{{ $t("cuentaYFacturacion.datosFacturacion.telefono") }}*</b
              ></label
            >
            <div class="p-inputgroup">
              <InputText
                class="input"
                :class="!validations.telefono ? 'p-invalid' : ''"
                id="telefono"
                type="phone"
                v-model="datosFacturacion.telefono"
                maxLength="9"
                minLength="9"
              />
            </div>
            <small v-if="!validations.telefono" class="p-invalid">{{
              this.$t("common.formularios.mandatoryp-field")
            }}</small>
          </div>
          <!-- Nombre/Razón social -->
          <div class="col-12 p-field" :class="this.showApellidos && 'md:col-6'">
            <label for="nombre"
              ><b
                >{{
                  this.showApellidos
                    ? $t("cuentaYFacturacion.datosFacturacion.nombre")
                    : $t("cuentaYFacturacion.datosFacturacion.razonSocial")
                }}*</b
              ></label
            >
            <div class="p-inputgroup">
              <InputText
                class="input"
                :class="!validations.nombre ? 'p-invalid' : ''"
                id="nombre"
                type="text"
                v-model="datosFacturacion.nombre"
              />
            </div>
            <small v-if="!validations.nombre" class="p-invalid">{{
              this.$t("common.formularios.mandatoryp-field")
            }}</small>
          </div>
          <!-- Apellidos -->
          <div class="col-12 md:col-6 p-field" v-if="this.showApellidos">
            <label for="apellidos"
              ><b
                >{{ $t("cuentaYFacturacion.datosFacturacion.apellidos") }}*</b
              ></label
            >
            <div class="p-inputgroup">
              <InputText
                class="input"
                :class="!validations.apellidos ? 'p-invalid' : ''"
                id="apellidos"
                type="text"
                v-model="datosFacturacion.apellidos"
              />
            </div>
            <small v-if="!validations.apellidos" class="p-invalid">{{
              this.$t("common.formularios.mandatoryp-field")
            }}</small>
          </div>
          <!-- Tipo Impuesto -->
          <div class="col-12 md:col-6 p-field">
            <label for="tipoImpuesto"
              ><b
                >{{
                  $t("cuentaYFacturacion.datosFacturacion.tipoImpuesto")
                }}*</b
              ></label
            >
            <div class="p-inputgroup">
              <Dropdown
                class="input"
                v-model="selectedTipoImpuesto.id"
                :class="!validations.tipoImpuesto ? 'p-invalid' : ''"
                :options="this.dropdownTipoImpuesto"
                optionLabel="descripcion"
                optionValue="id"
              />
            </div>
            <small v-if="!validations.tipoImpuesto" class="p-invalid">{{
              this.$t("common.formularios.mandatoryp-field")
            }}</small>
          </div>
          <!-- Dirección -->
          <DireccionIcired
          :required="true"
          ref="direccionComponent"
          />
          <div class="col-12 actions">
            <Button
              :label="$t('common.buttons.save')"
              @click.prevent="onSubmit()"
              :disabled="this.isSubmitting"
            ></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import DireccionIcired from "@/components/portal-cliente/Utils/DireccionIcired.vue";
import Errors from "@/components/utilidades/Errors";
import validations from "@/utils/validations.js";
import { LISTADO_TIPO_IMPUESTO } from "@/graphQLQueries/TipoImpuestoQueries";
import {
  GET_TIPO_IMPUESTO_BY_CLIENTE,
  ALTA_TIPO_IMPUESTO_CLIENTE,
} from "@/graphQLQueries/TipoImpuestoClienteQueries";
import { GET_CLIENTE, MODIFICA_CLIENTE } from "@/graphQLQueries/ClienteQueries";
import MessagesMixin from "@/utils/messages";


export default {
  name: "DatosFacturacion",
  components: { Errors, DireccionIcired },
  data() {
    return {
      datosFacturacion: {
        nifNieCif: "",
        telefono: "",
        nombre: "",
        apellidos: "",
        tipoImpuesto: null,
        direccion: {
          province: "",
          location: "",
          postalCode: "",
          typeOfRoad: "",
          address: "",
        },
      },
      selectedTipoImpuesto: [],
      dropdownTipoImpuesto: [],
      errors: [],
      validations: {
        nifNieCif: true,
        telefono: true,
        nombre: true,
        apellidos: true,
        tipoImpuesto: true,
        direccion: true,
      },
      showApellidos: true,
      isSubmitting: false,
      cliente: null,
      tipoImpuestoCliente: null,
    };
  },
  mixins: [MessagesMixin],
  updated() {
    this.showApellidosValid()
  },
  methods: {
    onSubmit() {
      if (this.valid()) {
        const direccionData = this.$refs.direccionComponent.getData();
        this.isSubmitting = true;

        this.$apollo
          .mutate({
            mutation: MODIFICA_CLIENTE,
            variables: {
              modificarClienteRequest: {
                nombre: this.datosFacturacion.nombre,
                apellidos: this.isCifCompany
                  ? null
                  : this.datosFacturacion.apellidos,
                nuevoIdLegal: this.datosFacturacion.nifNieCif,
                antiguoIdLegal: this.cliente.idLegal,
                datosFacturacion: true,
                contactoDireccion: direccionData,
                contactoTelefono: { telefono: this.datosFacturacion.telefono },
              },
            },
            
          })
          .then(() => {
            this.isSubmitting = false;
            this.$apollo
              .mutate({
                mutation: ALTA_TIPO_IMPUESTO_CLIENTE,
                variables: {
                  altaTipoImpuestoClienteRequest: {
                    idCliente: this.cliente.id,
                    idTipoImpuesto: this.selectedTipoImpuesto.id
                  }
                },
              })
              .then(() => {
                this.reloadData();
                this.setMessages(
                  "success",
                  this.$t("common.success.save"),
                  3000
                );
                this.isSubmitting = false;
              })
              .catch((error) => {
                this.reloadData();
                this.isSubmitting = false;
                console.error(error);
              });
          })
          .catch((error) => {
            this.reloadData();
            this.isSubmitting = false;
            console.error(error);
          });
      }
    },
    validate() {
      let apellidosValidate = true
      if (this.showApellidos && !this.datosFacturacion.apellidos)
        apellidosValidate = false

      this.validations = {
        nifNieCif:
          !!this.datosFacturacion.nifNieCif &&
          (validations.isValidCif(this.datosFacturacion.nifNieCif) ||
            validations.validateNif(this.datosFacturacion.nifNieCif)),
        telefono:
          !!this.datosFacturacion.telefono ||
          (this.datosFacturacion.telefono &&
            this.datosFacturacion.telefono.length != 9),
        nombre: !!this.datosFacturacion.nombre,
        apellidos: apellidosValidate ,
        tipoImpuesto: !!this.selectedTipoImpuesto,
        direccion: this.$refs.direccionComponent.valid(),
      };
    },

    valid() {
      this.validate();
      return Object.values(this.validations).reduce(
        (previousValue, currentValue) => previousValue && currentValue
      );
    },
    onNifNieCifChange() {
      this.datosFacturacion.nombre = "";
      this.datosFacturacion.apellidos = "";
    },
    showApellidosValid() {
      this.showApellidos = !validations.isValidCif(
        this.datosFacturacion.nifNieCif
      )
    },
    reloadData(){
      this.$apollo.queries.cliente.refetch()
      this.$apollo.queries.tipoImpuestoCliente.refetch()
      this.$apollo.queries.dropdownTipoImpuesto.refetch()
    }
  },
  apollo: {
    cliente: {
      query: GET_CLIENTE,
      variables() {
        return {
          idLegal: this.$store.state.clienteIdLegal,
          idioma: this.$i18n.locale,
        };
      },
      update({ cliente }) {
        if (cliente) {
          if (cliente.contactosActivos.direccion) {
            const { valor } = cliente.contactosActivos.direccion;
            if (this.$refs.direccionComponent) {
              this.$refs.direccionComponent.setData({
                province: valor.provincia,
                location: valor.localidad,
                postalCode: valor.codigoPostal,
                typeOfRoad: valor.tipoDireccion,
                address: valor.direccion,
              });
            }
          }
          this.datosFacturacion = {
            nifNieCif: cliente.idLegal,
            telefono: cliente.contactosActivos.telefono ? cliente.contactosActivos.telefono.valor.telefono : null,
            nombre: cliente.nombre,
            apellidos: cliente.apellidos,
          };

          if (this.datosFacturacion && this.datosFacturacion.contactosActivos) {
            if (this.datosFacturacion.contactosActivos.telefono) {
              this.datosFacturacionTelefono =
                this.datosFacturacion.contactosActivos.telefono.valor.telefono;
            }
            if (this.datosFacturacion.contactosActivos.direccion) {
              const { valor } =
                this.datosFacturacion.contactosActivos.direccion;

              this.$refs.direccionComponent.setData({
                province: valor.provincia,
                location: valor.localidad,
                postalCode: valor.codigoPostal,
                typeOfRoad: valor.tipoDireccion,
                address: valor.direccion,
              });
            }
          }
        }
        return cliente;
      },
    },
    tipoImpuestoCliente: {
      query: GET_TIPO_IMPUESTO_BY_CLIENTE,
      variables() {
        return { idCliente: this.cliente ? this.cliente.id : null };
      },
      update(data) {
        this.selectedTipoImpuesto = data.getTipoImpuestoCliente.tipoImpuesto
      },
    },
    dropdownTipoImpuesto: {
      query: LISTADO_TIPO_IMPUESTO,
      update({ listadoTipoImpuesto }) {
        return listadoTipoImpuesto;
      },
    },
  },
};
</script>

<style scoped>
.actions {
  display: flex;
  justify-content: right;
  margin-top: 15px;
}
</style>